export const LoadingMessage = "Loading. Your results are on the way";
export const AbLoadingTips = [
    "We’re preparing your data - Thanks for your patience",
    "Good things take a little time, we’re on it",
    "We know waiting isn’t fun, thanks for your patience",
    "While we’re processing: Have you explored the User conversion based on events set feature?",
    "Did you know? You can view Retention metrics by daydiff",
    "Feel free to explore any new events & event params just by adding them in search box",
];

export const ISLoadingTips = [
    "We’re preparing your data - Thanks for your patience",
    "Good things take a little time, we’re on it",
    "We know waiting isn’t fun, thanks for your patience",
    "Did you know? You can explore multiple questions in parallel”",
    "While we’re processing: Have you tried Segmentation analysis feature?",
    "Custom metrics are already supported in SAT. Let’ try to create ones!",
];
